import { planningAPI } from "../../axios";

export const actions = {

    // TargetTemplatePriorityApi
    GetTargetTemplatePriorityApi(context, data){
        return planningAPI.get(`TargetTemplatePriorityApi/${data}`);
    },
    GetTargetTemplatePriorityApiByMainTarget(context, data){
        return planningAPI.get(`TargetTemplatePriorityApi/Template/${data}`);
    },
    UpdateTargetTemplatePriorityApi(context, data){
        return planningAPI.put(`TargetTemplatePriorityApi/${data.id}`, data);
    },
    DeleteTargetTemplatePriorityApi(context, data){
        return planningAPI.delete(`TargetTemplatePriorityApi/${data}`);
    },
    CreateMultipleTargetTemplatePriorityApi(context, data){
        return planningAPI.post(`TargetTemplatePriorityApi/Add/Multiple`, data);
    },
}